<template>
  <div>
    <Header></Header>
    <div class="ceping">
      <!-- 微导航 -->
      <div class="wnav">
        <span>课程体系</span> >
        <span>更多测评</span> >
        <span>测评详情</span> >
        <span class="gengduo">{{name}}</span>
      </div>
      <div class="cont">
        <div class="cont-t">
          <img src="../../assets/img/pinc.png" alt="">
          <div class="cont1">您已经完成测评问卷</div>
          <div class="cont2">点击下方按钮查看结果</div>
          <div class="btn" @click="gores()">测评结果</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../header";
import Footer from "../footer";
export default {
  name: "",
  data() {
    return {
      id:"",
      name:""
    };
  },
  created(){
     var id = this.$route.query.id;
     this.id=id;
      var title = this.$route.query.name;

    this.name = title;
  },
  methods: {
    gores(){
      this.$router.push({
        path:"/evalu_result",
        query:{
          id:this.id,
          name:this.name,
        }
      })
    },
  },
  components: {
    Header,
    Footer
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ceping {
  width: 1200px;
  margin: 0 auto;
}
/* 微导航 */
.ceping .wnav {
  height: 30px;
  line-height: 40px;
  font-size: 14px;
  margin-bottom: 10px;
}
.ceping .wnav span.gengduo {
  color: rgba(136, 136, 136, 1);
}
.ceping .cont {
  width: 1200px;
  height: 828px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ceping .cont .cont-t{
  height: 250px;
  width: 200px;
  text-align: center;
}
.ceping .cont .cont-t .cont1{
  font-size:20px;
  font-weight:500;
  color:rgba(51,51,51,1);
  line-height:28px;
  margin-bottom: 19px;
}
.ceping .cont .cont-t .cont2{
  font-size:16px;
  font-weight:500;
  color:rgba(136,136,136,1);
  line-height:22px;
  margin-bottom: 25px;
}
.ceping .cont .cont-t .btn{
  width:154px;
  height:44px;
  background:rgba(23,117,239,1);
  border-radius:22px;
  margin: 0 auto;
  font-weight:500;
  color:rgba(255,255,255,1);
  line-height:44px;
}
</style>



// WEBPACK FOOTER //
// src/components/cptx/evalu_success.vue